import React, { Component } from "react";
import { Row } from "reactstrap";

class ItemList extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };

        // Bind Here
        //
    }

    render() {
        const { items } = this.props;
        if(items == null)  return ( <div className="w100"> No se encontró. </div>)
        return (
            <div className="w100">
                <Row>
                    Lista
                </Row>
            </div>
        )
    }   
}

export default ItemList;


// WEBPACK FOOTER //
// ./src/components/RemoteSellComponents/ItemList/ItemList.js